import Roles, { RoleTypes } from "./roles";








export enum PermissionTypes {
  ProjectEdit,
  ProjectReviewersAssign,
  ProjectReviewersList,
  ProjectReviewsListMine,
  ProjectReviewsListAll,
  ProjectResourcesCreate,
  ProjectResourcesEdit,
  ProjectUnitEvaluationsListMine,
  ProjectUnitEvaluationsListAll,
  ReviewEditMine,
  ReviewEditAll,
  ResourceReviewsListAll,
  ProjectSearch,
  ReviewDelete,
  SurveysList,
};


export const roleHasPermission = (role: string, permission: PermissionTypes): boolean => {

  // Permissions everyone has
  // debugger;

  switch (role) {
    case Roles.Admin:
      return true;
    case Roles.Analyst:
      switch (permission) {
        case PermissionTypes.ProjectEdit:
        case PermissionTypes.ProjectReviewersList:
        case PermissionTypes.ProjectReviewersAssign:
        case PermissionTypes.ProjectReviewsListAll:
        case PermissionTypes.ProjectResourcesCreate:
        case PermissionTypes.ProjectResourcesEdit:
        case PermissionTypes.ProjectUnitEvaluationsListAll:
        case PermissionTypes.ReviewEditAll:
        case PermissionTypes.ProjectReviewsListMine:
        case PermissionTypes.ProjectUnitEvaluationsListMine:
        case PermissionTypes.ReviewEditMine:
          return true;
        default:
          break;
      }
      break;
    case Roles.Reviewer:
      switch (permission) {
        case PermissionTypes.ProjectReviewsListMine:
        case PermissionTypes.ProjectUnitEvaluationsListMine:
        case PermissionTypes.ReviewEditMine:
          return true;
      }
      break;
    case Roles.SCAnalyst:
    case Roles.SCUser:
      switch (permission) {
        case PermissionTypes.SurveysList:
          return true;
      }
      break;
    default:
      // No role
      return false;
  }

  // All Users
  return false;
};